import { apiAgent } from "../services/apiAgent";

export default {
  async getAccountData() {
    return apiAgent.get("account/account-data/");
  },
};
